module.exports = {
    APISERVICE : process.env.VUE_APP_APISERVICE,
    URLIMAGE: process.env.VUE_APP_URLIMAGE
  }